const PAIN_LOCATION_REQUEST_PATTERNS = [
  /\b(show|point|pinpoint|mark|circle|tap|highlight|select|indicate)\b.*\b(where|location|area|spot|part)\b.*\b(pain|hurt|hurts|ache|discomfort|sore)\b/i,
  /\bwhere\b.*\b(pain|hurt|hurts|ache|discomfort|sore)\b/i,
  /\bpin[\s-]*point\b.*\b(pain|location)\b/i,
  /\bmark\b.*\bon\b.*\b(body|map|diagram|figure)\b/i,
  /\b(tap|circle|mark|select)\b.*\b(body|pain)\s*\b(map|diagram|figure)\b/i,
];

const PAIN_WORD_PATTERN = /\b(pain|hurts?|ache|aching|sore|discomfort|tender)\b/i;
const BODY_PART_PATTERN =
  /\b(head|neck|back|chest|stomach|abdomen|belly|arm|shoulder|elbow|wrist|hand|hip|leg|knee|ankle|foot)\b/i;
const VERBAL_LOCATION_PATTERN =
  /\bwhere\b.*\b(pain|hurt|ache|located|location)\b/i;
const VERBAL_LOCATION_OPTIONS_PATTERN =
  /\b(thigh|knee|calf|ankle|shin|upper leg|lower leg)\b/i;
const FIGURE_MAP_PATTERN = /\b(map|figure|diagram|tap|circle|mark)\b/i;
const LOCATION_REJECTION_PATTERN =
  /\b(no|not|wrong|incorrect|different|elsewhere|another|other)\b/i;
const LOCATION_REFERENCE_PATTERN =
  /\b(area|spot|location|point|marked|mark|pointed|pinpoint|figure|map)\b/i;

export function isPainLocationRequest(text) {
  if (!text || typeof text !== 'string') return false;
  return PAIN_LOCATION_REQUEST_PATTERNS.some((pattern) => pattern.test(text));
}

export function isPainComplaint(text) {
  if (!text || typeof text !== 'string') return false;
  return PAIN_WORD_PATTERN.test(text) && BODY_PART_PATTERN.test(text);
}

export function isVerbalLocationQuestion(text) {
  if (!text || typeof text !== 'string') return false;
  if (!VERBAL_LOCATION_PATTERN.test(text)) return false;
  if (FIGURE_MAP_PATTERN.test(text)) return false;
  return VERBAL_LOCATION_OPTIONS_PATTERN.test(text) || /exactly/i.test(text);
}

export function isPainLocationCorrection(text) {
  if (!text || typeof text !== 'string') return false;
  return LOCATION_REJECTION_PATTERN.test(text) && LOCATION_REFERENCE_PATTERN.test(text);
}

